import { Timestamp } from "firebase/firestore/lite";

export interface DbBusinessCalendar {
  id: string;
  name: string;
  description?: string;
  image?: string | null;
  availability: any;
  created_at?: Timestamp | null;
  updated_at?: Timestamp | null;
  custom_availability_enabled?: boolean;
  index?: number;
  calendar_status: DbCalendarStatus;
}

export enum DbCalendarStatus {
  enable = "enable",
  disable = "disable",
  deleted = "deleted",
}
